<template>
  <div class="d-flex flex-column align-center ga-2">
    <div class="title">
      {{$t('Языки страницы')}}
    </div>
    <div class="description">
      {{$t('Настройка языков страницы и их порядка. Первый язык в списке является основным')}}
    </div>
  </div>
  <div>
    <draggable v-model="langs" item-key="id" handle=".drag" ghost-class="ghost" chosen-class="chosen"
               :force-fallback="true" class="mt-4 mb-4 d-flex flex-column ga-4" @end="reindex">
      <transition-group type="transition">
        <div v-for="(lang, index) in langs" :key="lang.id" class="d-flex justify-space-between w-100 align-center">
          <div class="d-flex align-center w-75">
            <DragElement custom-class="cursor-grab drag" color="BW-400-Border" size="16"/>
            <div class="text">
              <div>{{$t(lang.lang)}} {{index == firstEnabledIndex ? `(${$t('основной')})` : ''}}</div>
              <div v-if="lang.active" class="sub">{{`${host}/${tapStore.currentTap?.alias}`}}{{index == firstEnabledIndex ? '' : `/${lang.lang}` }}</div>
            </div>
          </div>
          <v-switch v-model="lang.active" hide-details inset :disabled="oneEnabled && lang.active"></v-switch>
        </div>
      </transition-group>
    </draggable>
  </div>
  <v-btn variant="flat" color="primary" @click="saveChanges" rounded="lg" class="w-100">
    {{$t('Сохранить')}}
  </v-btn>
</template>

<script setup lang="ts">
import DragElement from "@/components/DragElement.vue";
import { VueDraggableNext as draggable } from 'vue-draggable-next'
import {computed, onMounted, ref} from "vue";
import {useTapStore} from "@/stores/tapStore";
import { cloneDeep } from "lodash-es"
import {useDialogStore} from "@/stores/dialogStore";
import {useRoute, useRouter} from "vue-router";

const dialogStore = useDialogStore()
const tapStore = useTapStore()
const router = useRouter()
const route = useRoute()
const config = useRuntimeConfig()
const host = config.public.tapLink;

const langs = ref([
  {lang: 'KZ', active: false, orderIndex: 0, id: 1},
  {lang: 'RU', active: false, orderIndex: 1, id: 2},
  {lang: 'EN', active: false, orderIndex: 2, id: 3}
])

const oneEnabled = computed(() => {
  return langs.value.filter(l => l.active).length == 1
})

const firstEnabledIndex = computed(() =>
    langs.value.findIndex(i => i.active)
);

const saveChanges = () => {
  reindex()
  const basePath = route.path.replace(/\/(ru|en|kz)\/?$/, '')
  tapStore.setLanguages(cloneDeep(langs.value), router, basePath)
  dialogStore.close()
}

const reindex = () => {
  langs.value = langs.value.map((lang, index) => ({...lang, orderIndex: index}))
}

onMounted(() => {
  const map = new Map(tapStore.languageSettings.map(l => [l.lang, l]));
  langs.value = langs.value.map((lang, index) => {
    const fromStore = map.get(lang.lang);

    return {
      ...lang,
      active: fromStore?.active ?? false,
      edited: fromStore?.edited ?? false,
      orderIndex: fromStore?.orderIndex ?? index
    };
  }).sort((a, b) => a.orderIndex - b.orderIndex);
})

</script>

<style scoped lang="sass">
.title
  color: #000
  text-align: center
  font-size: 20px
  font-style: normal
  font-weight: 600
  line-height: normal
.description
  color: #363636
  text-align: center
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: normal
  max-width: 328px
.text
  color: #363636
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: normal
  letter-spacing: 0.14px
  margin-left: 10px
  width: 100%
  .sub
    color: #8D959D
    font-size: 12px
    letter-spacing: 0.12px
    margin-top: 2px
    text-transform: lowercase
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap

.chosen
  opacity: 1 !important

.ghost
  opacity: 0 !important
</style>
